// src/components/orders/OrderShiftLink/OrderShiftLink.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ExternalLink } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import { usePermissions } from '../../../hooks/usePermissions';
import { useBusinessSettings } from '../../../hooks/useBusinessSettings';
import { formatDate } from '../../../utils/dateUtils';
import styles from './OrderShiftLink.module.css';

// Message center shift label (type · date), linked to the shift details page when the user may view shifts
const OrderShiftLink = ({ shiftMap, className = '' }) => {
  const { t } = useLocalization();
  const { hasPermission } = usePermissions();
  const { settings: messageCenterSettings } = useBusinessSettings('messageCenter');

  const shift = shiftMap?.shift;
  if (!shift) return null;

  const label = [shift.shiftType?.name, formatDate(shift.shiftDate)].filter(Boolean).join(' · ');
  const shiftId = shiftMap.shiftId || shift.id;
  const canOpen = messageCenterSettings.enabled && hasPermission('view_message_center_shifts') && shiftId;

  if (!canOpen) {
    return (
      <span className={`${styles.shiftText} ${className}`}>
        <Clock size={14} />
        {label}
      </span>
    );
  }

  return (
    <Link
      to={`/message-center/shifts/${shiftId}`}
      className={`${styles.shiftLink} ${className}`}
      title={t('ecomOrders.viewShift')}
      onClick={(e) => e.stopPropagation()}
    >
      <Clock size={14} />
      <span>{label}</span>
      <ExternalLink size={12} />
    </Link>
  );
};

export default OrderShiftLink;
